import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: {
        //Labels
        cardboard: "Cardboard",

        title_count: "Items Counted",
        title_weight: "Total Weight",
        title_revenue: "Potential Revenue (CHF)",
        title_timeline: "Number of bales processed",
        title_table: "Most recent detections",
        title_num_labels: "Bales labelled",

        timeframe_title: "Set time frame",
        timeframe_today: "Today",
        timeframe_yesterday: "Yesterday",
        timeframe_this_week: "This Week",
        timeframe_last_week: "Last Week",
        timeframe_this_month: "This Month",
        timeframe_last_month: "Last Month",
        timeframe_this_year: "This Year",
        timeframe_all: "All Time",
        last_six_months: "Last Six Months",

        material_filter_title: "Materials",
        material_filter_all: "All",

        navbar_hello: "Hi",
        navbar_language: "Language",
        navbar_logout: "Logout",

        table_time: "Time",
        table_date: "Date",
        table_objecttype: "Object Type",

        sidebar_dashboard: "Overview",
        sidebar_deliveries: "Deliveries",
        sidebar_plant_feed: "Plant Feed",
        sidebar_claims: "Claims",
        sidebar_admin_settings: "Settings",
        sidebar_labeling: "Data Labeling",
        sidebar_shift_report: "Shift Report",
        sidebar_material_flow: "Material Flow",
        sidebar_device_statuses: "Device Status",
        sidebar_navigation: "Navigation",
        sidebar_admin: "Admin",
        sidebar_supplier_insights: "Supplier Insights",
        sidebar_log_insights: "Log Insights",

        loading: "Loading . . .",
        device_not_found_error:
          "Devices not found. Please refresh, or contact the UpCircle team. ",
        user_no_role:
          "For the current user no role was defined. Please contact an admin.",

        deliveries_card_title: "Deliveries",
        bales_received_card_title: "Bales Received",
        material_received_card_title: "Material Received",
        n_deliveries_card_title: "Number of Deliveries",
        material_piechart_card_title: "Material Distribution",

        delivery_title: "Delivery",
        delivery_create_report: "Create Report",
        delivery_delete: "Delete Delivery",
        delivery_registered_images: "Photos Images",
        delivery_registered_bales: "Registered Bales",
        delivery_mismatch: "mismatch",
        delivery_new: "New Delivery",
        no_deliveries: "No deliveries registered.",
        delivery_image_show_bbox: "Show Bounding Boxes",
        delivery_claim_title: "Claim Report",
        delivery_claim_images: "Photos Claim",
        delivery_filter_claims: "Only Claims",
        delivery_no_images: "No images registered.",
        delivery_create_claim: "Register new Claim",
        delivery_delete_claim: "Remove Claim",
        delivery_discard_claim: "Discard",
        delivery_confirm_claim: "Confirm",
        delivery_no_claim: "No claim for this delivery registered.",
        delivery_new_claim_title: "New Claim",
        delivery_delete_claim_confirm:
          "Are you sure you want to remove this claim?",
        delivery_discard_claim_draft_confirm:
          "Are you sure you want to discard the claim?",
        delivery_delete_claim_date: "Date",
        delivery_delete_claim_user: "User",
        delivery_documents_scanned: "Documents",
        delivery_no_documents_scanned: "No documents",
        document_type_weighing_slip: "Weighing Slip",
        document_type_delivery_slip: "Delivery Slip",

        bale_title: "Bale",
        bale_delete: "Delete Bale",

        property_material: "Material",
        property_weight: "Weight",
        property_weight_kg: "Weight Kg",
        property_supplier: "Supplier",
        property_date: "Date",
        property_time: "Time",
        property_quality: "Quality",
        property_notes: "Notes",
        property_location: "Location",
        property_submitted_by: "Submitted By",
        property_n_bales: "Num. Bales",
        property_registered_bales: "Registered Bales",
        property_conflicts: "Conflicts",
        property_price: "Purchase Price",
        property_photos: "Photos",
        property_truck_license_plate: "Truck License Plate",
        property_dispo_number: "Dispo Number",
        property_bale_mark: "Bale Mark",
        property_document_scanner: "Document Scanner",
        property_supplier_no: "SUPPLIER NO",
        property_supplier_name: "SUPPLIER NAME",
        property_order_no: "ORDER NO",
        property_license_plate: "LICENSE PLATE TRUCK",
        property_weight_first: "1. WEIGHING",
        property_weight_second: "2. WEIGHING",
        property_weight_netto_1: "NETTO I",
        property_weight_netto_2: "NETTO II",
        property_doc_type: "DOCUMENT TYPE",
        property_slip_nr: "DOCUMENT NR",

        modal_delivery_delete_title:
          "Are you sure you want to delete this delivery?",
        modal_bale_delete_title: "Are you sure you want to delete this bale?",
        modal_cancel: "Cancel",
        modal_delete: "Delete",

        title_dayreview: "Hourly Overview",
        dayreview_time: "Time",
        dayreview_bales: "Bales",
        dayreview_nbales: "Num Bales",
        dayreview_shift_time: "Shift start",

        title_daysummary: "Summary",
        subtitle_daysummary: "Plant information",
        subtitle_dayreview: "All detections of the day",
        daysummary_weight: "Processed Weight",
        daysummary_num_bales: "Processed Bales",
        daysummary_material: "Processed Materials",
        daysummary_tons: "tons",
        daysummary_bales: "bales",

        title_devicestatus: "Device Status",
        devicestatus_no_disruptions: "No disruptions detected",
        devicestatus_disrupted: "Disruptions detected",
        devicestatus_percentage_1: "Device was online for",
        devicestatus_percentage_2: "",

        labeling_mode_requested: "Labeling Requests",
        labeling_mode_randomized: "Randomized",
        labeling_mode_pairwise: "Pairwise Comparison",
        labeling_mode_conflicts: "Labeling Conflicts",
        labeling_title: "Set bale material label",
        quality_labeling_title: "Set bale quality label",
        labeling_no_label: "no label",
        labeling_you_labeled: "You labeled",
        labeling_bales_today: "bales today!",
        alert_low_accuracy: "low confidence",
        labeling_conflicts_open: "Open Conflicts",
        labeling_conflicts_resolved: "Resolved Conflicts",

        liveview_title: "Autonomous Bale Scanner - Live View",
        liveview_choice_camera: "Camera Feed",
        liveview_choice_predictions: "AI Analysis",
        liveview_error:
          "No stream available. Please contact the UpCircle team.",

        supplier_filter_title: "Supplier",
        search_suppliers: "Search suppliers...",
        search_companies: "Search companies...",
        no_results_found: "No suppliers found",
        no_companies_found: "No companies found",
        clear_search: "Clear search",
        multi_select_title_empty: "none",
        multi_select_title: "selected",

        settings_new_client: "New Client",
        settings_users: "Users",
        settings_create_new_user: "Create New User",
        settings_edit_user: "Edit User",
        settings_devices: "Devices",
        settings_create_new_device: "Create New Device",
        settings_edit_device: "Edit Device",
        settings_no_devices_found: "No devices found for selected client.",
        settings_device_id: "Device ID",
        settings_device_display_name: "Display Name",
        settings_device_location_name: "Location Name",
        settings_device_description: "Description",
        settings_device_local_ip: "IP Address",
        settings_device_company: "Company",
        settings_device_emails: "Notification Emails",
        settings_device_add_email: "Add Email",
        settings_device_filters: "Filter Classes",
        settings_device_add_filter: "Add Class",
        settings_device_confirm_reboot: "Do you want to reboot the pipeline?",
        settings_device_confirm_save: "Changes have been saved.",
        settings_save: "Save",
        settings_client_create: "Create Client",
        settings_client_id: "Client ID",
        settings_client_name: "Display Name",
        settings_client_low_accuracy_flag: "Flag Low Accuracy",
        settings_client_add_low_accuracy_flag: "Add Low Accuracy Flag",
        settings_user_last_login: "Last Login",
        settings_user_company: "Company",
        settings_user_name: "Name",
        settings_user_language: "Language",
        settings_user_flags: "User Flags",
        settings_user_add_flag: "Add User Flag",
        settings_user_email: "Email",
        settings_user_password: "Password",
        settings_user_error_fields:
          "All input fields must be correctly filled out.",
        settings_user_error_email: "This email already exists",
        settings_user_error_pw: "Passwords needs at least 6 characters.",
        settings_user_confirm_create:
          "Would you like to create a new user? It will take about one minute for the user to be created.",
        settings_user_reset_password: "Send Reset Email",
        settings_user_reset_password_message:
          "Send email to reset password to user?",
        settings_user_change_credentials: "Change credentials",
        settings_user_change_credentials_message:
          "Are you sure you want to change the user's login credentials?",
        settings_yes: "Yes",
        settings_cancel: "Cancel",
        settings_report_standstill: "Report Material-Flow Standstill",
        settings_stanstill_threshold: "Standstill Threshold (min)",
        settings_report_stamp_inactivity: "Report Stamping Inactivity",
        settings_stamp_inactivity_threshold: "Inactivity Threshold (min)",
        settings_enable_chat_alerts: "Enable Google-Chat Alerts",

        shift_report_saving: "Saving...",
        shift_report_offline: "Offline",
        shift_report_last_save: "Last save",

        claims_table_card_title: "claims",
        claim_nr: "Report Nr.",
        claim_card_title: "claim View",
        claim_images_title: "Registered Images",
        no_claims: "No claims registered.",
        claim_download_report: "Download Report",
        claim_download_report_title: "Download claim Report",
        claim_download_report_generating: "Generating Report",
        claim_download_report_error:
          "An error occurred while generating the report.",
        claim_delete_note_title: "Are you sure you want to delete this note?",

        timeline_normalize: "Normalize",
        timeline_force_hourly: "Show hourly data",

        material_flow_loading_error:
          "Error loading material flow data for given date.",
        material_flow_toggle_bbox_labeling: "Toggle bounding box editing (B)",
        material_flow_edit: "Edit",
        material_flow_delete_text: "Delete bounding box and associated bale",
        material_flow_confirm_text: "Confirm bounding box",
        material_flow_editing_text: "Draw Bounding Boxes (E)",
        material_flow_show_in: "Show in Material Flow",

        demo_mode_company_displayname: "",

        productGroup: "Material Group",
        uncategorized: "uncategorized",

        // Shared Components
        labeling_select_recommended: "Recommended",
        labeling_select_others: "Others",
        labeling_request: "Labeling Request",
        labeling_skip: "Skip bale",
        labeling_accept: "Accept labels",
        labeling_no_more_requests: "No more labeling requests found.",
        license_agreement_title: "License Agreement",
        license_agreement_decline: "Decline",
        license_agreement_accept: "Accept",

        // Supplier Table Component
        supplier_name: "Supplier Name",
        table_columns: "Table Columns",
        all: "All",
        reset: "Reset",
        tier: "Tier",
        score: "Score",
        deliveries: "Deliveries",
        claims: "Claims",
        claims_per_ton: "Claims/20t",
        claims_per_delivery: "Claims/Delivery",
        total_bales_in_production: "Bales in Production",
        bales_with_plastic_foils: "Contaminated Bales (%)",
        plastic_foils_per_bale: "Avg. Plastics in all Bales",
        contamination_level: "Avg. Plastics in Contaminated Bales",
        items_per_page: "Items per page",
        found_suppliers: "Suppliers found",
        filtered_by: "Filtered by",
        loading_supplier_details: "Loading supplier details...",
        no_suppliers_found: "No suppliers found matching the current filters",
        no_supplier_data: "No supplier data available",
        search_results_info: "Search results",
        none: "None",
        search_for: "Search for",
        to: "to",
        brown_paper_percentage: "Brown-Paper Percentage",
        avg_brown_paper_percentage: "Avg Brown-Paper %",

        // Supplier chart component
        contaminant: "Contaminant",
        time_range: "Time Range",
        contaminated_bales: "Contaminated Bales",
        contaminated_bales_percentage: "of {{y}} ({{z}}%)",
        foils_detected: "Avg. Detections per Bale (All Bales)", // y-axis label -> in all bales
        x_per_bale: "per bale",
        contaminated_area: "Contaminated Area",
        x_of_bale_surface: "of bale surface",
        contaminated_qty: "Contaminated Qty.",
        contaminated_qty_label: "Avg. Detections per Bale (Affected)",  // y-axis label -> in contaminated bales
        contaminations_in_contaminated_bales_tooltip: "Avg. Detections per Bale (Affected Bales)", // info tooltip
        //          "Verunreinigungen in kontaminierten Ballen",
        contaminations_in_contaminated_bales_value: "per affected bale",
        // "pro kontaminiertem Ballen",

        qty: "Qty",
        area: "Area",
        contaminant_count: "Avg. Detections per Bale (All Bales)", // y-axis label -> in all bales
        contaminant_foils_per_bale: "{{contaminant}} per Bale",
        contaminated_area_per_bale: "Contaminated Area per Bale",
        contaminated_bales_in_percentage: "Contaminated Bales %",

        // Supplier chart tooltips
        tooltip_contaminated_qty: "This metric indicates how contaminated are contaminated bales.",
        tooltip_qty: "This metric indicates how contaminated are all bales.",
        tooltip_area: "This metric indicates what percentage of the bale is typically contaminated (in area).",

        // Supplier Overview Component
        data_range: "Data range",
        overview: "Overview",
        plant_process: "Plant Process",
        issues: "Issues",
        code: "Code",
        total_tonnage: "Total Tonnage",
        tons_ytd: "Tons YTD",
        filter_active: "Active Filter",
        remove_filter: "Remove Filter",

        // Supplier chart section
        supplier_contamination_analysis: "Supplier Contamination Analysis",

        // OverviewTab Component
        deliveries_over_time: "Deliveries Over Time",
        material_distribution: "Material Distribution",
        latest_issue: "Latest Issue",
        issue_trend: "Issue Trend",
        last_30_days: "Last 30 days",
        recent_deliveries: "Recent Deliveries",
        no_issues_found: "No issues found",
        issue_reported: "Issue reported",
        increasing: "Increasing",
        decreasing: "Decreasing",
        stable: "Stable",
        no_issues: "No Issues",
        no_data: "No Data",
        tons: "tons",
        bales: "bales",
        unknown_weight: "Unknown weight",
        unknown_bales: "unknown bales",
        no_material_data:
          "No material data available for the selected time period",
        no_delivery_data:
          "No delivery data available for the selected time period",
        weight_tons: "Weight (tons)",
        number_of_deliveries: "Number of Deliveries",
        date: "Date",
        delivery_singular: "delivery",
        deliveries_plural: "deliveries",

        // DeliveriesTab Component
        delivery_history: "Delivery History",
        deliveries_count: "from this supplier",
        delivery: "delivery",
        no_deliveries_found: "No deliveries found for this supplier",
        no_deliveries_found_for_material:
          "No deliveries found for {{material}}",

        // PlantProcessTab Component
        plant_process_history: "Processing History",
        loading_processing_history: "Loading processing history...",
        no_processing_history:
          "No processing history available for this supplier.",
        loading_more: "Loading more...",
        no_more_entries: "No more entries",
        processed: "processed",
        processing_field: "Field",
        processing_shift: "Shift",
        processing_shift_worker: "Shift Worker",

        // IssuesTab Component
        issue_history: "Claim History",
        issues_count: "claim",
        issues_count_plural: "claims",
        no_confirmed_issues: "No confirmed claims for this supplier",
        delivery_date: "Delivery date",
        claim_issues_filter: "Claim Issues Filter",

        // Filter Components
        filter_material: "Material",
        filter_categories: "Claim Issues",
        filter_sort_by: "Sort By",
        filter_date_range: "Date Range",
        filter_deliveries_range: "Deliveries Range",
        filter_tonnage_range: "Tonnage Range",
        filter_bales_range: "Bales in Production",
        filter_reset: "Reset Filters",
        claim_without_issues: "Other",
        sort_by_name: "Name",
        sort_by_score: "Score (High to Low)",
        sort_by_deliveries: "Deliveries (High to Low)",
        sort_by_claims: "Claims (Low to High)",
        all_materials: "All Materials",
        select_dates: "Select dates",
        all_time: "All time",
        this_year: "This Year",

        // GroupingOptions Component
        group_all_suppliers: "All Suppliers",
        group_by_material: "By Material",
        group_by_ranking: "By Ranking Tiers",
        group_all_description: "Show all suppliers",
        group_material_description: "Group suppliers by material type",
        group_ranking_description: "Group suppliers by ranking tiers",
        coming_soon: "Coming Soon",

        // SuppliersByMaterial Component
        supplier_count_singular: "supplier",
        supplier_count_plural: "suppliers",
        deliveries_count_material: "deliveries",
        total_weight: "total weight",
        issue_count_singular: "claim",
        issue_count_plural: "claims",
        avg_score: "Avg Score",
        avg: "avg",

        // SupplierInsightsPage
        show_filters: "Show Filters",
        hide_filters: "Hide Filters",
        rank: "Rank",
        // Log Insights page
        log_insights_company: "Company",
        log_insights_user: "User",
        log_insights_source: "Source",
        log_insights_event: "Event",
        log_insights_showing_logs: "Showing",
        log_insights_logs: "logs",
        log_insights_load_more: "Load More",
        log_insights_load_all: "Load All",

        total_select_content_events: "Total select_content Events",
        unique_content_types: "Unique Content Types",
        content_type_analytics: "Content Type Analytics",

        total: "Total",
        other_materials: "Other Materials",

        // Table Tooltips
        material_specific_value: "Value for selected group",
        overall_value: "Total value across all groups",
        insufficient_data: "Insufficient data for reliable information",
        info_total_bales_in_production:
          "Number of bales processed by this supplier.",
        info_bales_with_plastic_foils:
          "Percentage of bales containing plastic foils. Measured on bales in the plant feed.",
        info_plastic_foils_per_bale:
          "Average number of plastic foils for all bales by the supplier. Measured on bales in the plant feed.",
        info_contamination_level:
          "Average number of plastic foils in a contaminated bale. Measured on bales in the plant feed.",
        info_brown_paper_percentage:
          "Average brown paper content of all bales in the plant feed.",
        info_total_tonnage:
          "Total weight (in tons) of all bales delivered to the plant during the selected period.",
        info_claims:
          "Number of claims registered for supplier. Define the types of claims considered in the filter options.",
        info_claims_per_ton:
          "Number of claims registered per 20t. Define the types of claims considered in the filter options.",
        info_claims_per_delivery:
          "Number of claims registered per delivery. Define the types of claims considered in the filter options.",
        claim_filter_all: "All",
        claim_filter_selected: "Selected",
        export_to_excel: "Excel",

        // Grid toggle
        grid_show: "Show Grid",
        grid_hide: "Hide Grid",

        // Timeline y-axis titles
        timeline_material_percentage: "Material Share %",
        timeline_material_count: "Number of Bales",
        timeline_bale_count: "Bale Count",
        timeline_contaminants_count: "Number of Detections",
        timeline_brown_paper_percentage: "Brown Paper %",
        timeline_brown_paper_raw: "Brown Paper Inlet",
        timeline_brown_paper_ema: "Brown Paper Pulper",
        timeline_volume: "Volume m³",

        // Timeline time unit patterns
        timeline_per_unit: "{{value}} per {{unit}}",
        timeline_time_unit_min: "{{minutes}} Minutes",
        timeline_time_unit_hour: "Hour",
        timeline_time_unit_day: "Day",

        // Timeline settings
        timeline_settings_title: "Timeline Settings",
        timeline_settings_time_interval: "Time Interval Data Points",
        timeline_settings_ema_period: "Smoothing Period",
        timeline_settings_use_ema: "Use Smoothing",
        timeline_settings_use_normalized: "Use Normalized",
        timeline_settings_show_suppliers: "Show Suppliers",

        // Timeline settings tooltips
        timeline_tooltip_time_interval:
          "Configure the time interval for data point aggregation in the timeline chart. Data is aggregated for the selected interval (sum / average).",
        timeline_tooltip_use_ema:
          "Enable smoothing of timeline data, which reflects the mixing of materials over time. The smoothing is calculated using an Exponential Moving Average (EMA). The last N data points are weighted with an exponential weighting factor, where the weighting decreases with increasing distance from the current data point.",
        timeline_tooltip_ema_period:
          "Set the period length for the Exponential Moving Average calculation. Longer periods result in a smoother curve and a stronger delay in response to changes.",
        timeline_tooltip_use_normalized:
          "Display data as normalized percentages for relative comparison",
        timeline_tooltip_show_suppliers:
          "Show supplier information in the timeline visualization. Data comes from the Stamping.",

        // Timeline card
        timeline_card_title: "Timeline Processed Material",

        // Timeline names
        timeline_bale_count_name: "Processed Bales",
        timeline_material_distribution_name: "Material Distribution",
        timeline_plastics_type_distribution_name: "Plastics Types",
        timeline_contaminants_name: "Contaminants",
        timeline_brown_paper_name: "Brown Paper Content",
        timeline_volume_flow_name: "Volume Flow",

        // Time units
        time_unit_min: "min",
        time_unit_day: "day",

        tag_show: "Show Detections",
        tag_hide: "Hide Detections",
      },
    },
    de: {
      translation: {
        //Labels
        cardboard: "Karton",

        title_count: "Anzahl Einheiten",
        title_weight: "Gesamtgewicht",
        title_revenue: "Potenzielle Einnahmen (CHF)",
        title_timeline: "Anzahl verarbeitete Ballen",
        title_table: "Zuletzt erkannte Einheiten",
        title_num_labels: "Ballen beschriftet",

        timeframe_title: "Zeitraum",
        timeframe_today: "Heute",
        timeframe_yesterday: "Gestern",
        timeframe_this_week: "Diese Woche",
        timeframe_last_week: "Letzte Woche",
        timeframe_this_month: "Dieser Monat",
        timeframe_last_month: "Letzter Monat",
        timeframe_this_year: "Dieses Jahr",
        timeframe_all: "Alles",
        last_six_months: "Letzte sechs Monate",

        material_filter_title: "Materialien",
        material_filter_all: "Alle",

        navbar_hello: "Hallo",
        navbar_language: "Sprache",
        navbar_logout: "Abmelden",

        table_time: "Zeit",
        table_date: "Datum",
        table_objecttype: "Objekttyp",

        sidebar_dashboard: "Übersicht",
        sidebar_deliveries: "Anlieferung",
        sidebar_plant_feed: "Anlagen Beschickung",
        sidebar_claims: "Reklamationen",
        sidebar_admin_settings: "Einstellungen",
        sidebar_labeling: "Datenbeschriftung",
        sidebar_shift_report: "Schichtbericht",
        sidebar_material_flow: "Materialfluss",
        sidebar_device_statuses: "Gerätestatus",
        sidebar_navigation: "Navigation",
        sidebar_admin: "Admin",
        sidebar_supplier_insights: "Lieferanten-Insights",
        log_insights_title: "Log Insights",

        loading: "Laden . . .",
        device_not_found_error:
          "Geräte nicht gefunden. Bitte aktualisieren Sie die Seite, oder kontaktieren Sie das UpCircle Team. ",
        user_no_role:
          "Für den Nutzer wurden keine Rollen definiert. Bitte kontaktieren sie einen Administrator.",

        deliveries_card_title: "Lieferungen",
        bales_received_card_title: "Erhaltene Ballen",
        material_received_card_title: "Erhaltenes Material",
        n_deliveries_card_title: "Anzahl Lieferungen",
        material_piechart_card_title: "Materialverteilung",

        delivery_title: "Lieferung",
        delivery_create_report: "Bericht erstellen",
        delivery_delete: "Lieferung löschen",
        delivery_registered_images: "Fotos Lieferung",
        delivery_registered_bales: "Registrierte Ballen",
        delivery_mismatch: "nicht übereinstimmend",
        delivery_new: "Neue Lieferung",
        no_deliveries: "Keine Lieferungen erfasst.",
        delivery_image_show_bbox: "Detektierungen anzeigen",
        delivery_claim_title: "Reklamationsbericht",
        delivery_claim_images: "Fotos Reklamation",
        delivery_filter_claims: "Nur Reklamationen",
        delivery_no_images: "Keine Fotos erfasst.",
        delivery_create_claim: "Reklamation erfassen",
        delivery_delete_claim: "Reklamation entfernen",
        delivery_discard_claim: "Verwerfen",
        delivery_confirm_claim: "Bestätigen",
        delivery_no_claim: "Keine Reklamation für diese Lieferung erfasst.",
        delivery_new_claim_title: "Neue Reklamation verfassen",
        delivery_delete_claim_confirm:
          "Sind Sie sicher, dass Sie folgende Reklamation entfernen möchten?",
        delivery_discard_claim_draft_confirm:
          "Sind Sie sicher, dass Sie die Reklamation verwerfen möchten?",
        delivery_delete_claim_date: "Datum",
        delivery_delete_claim_user: "Erfasser",
        delivery_documents_scanned: "Dokumente",
        delivery_no_documents_scanned: "Keine Dokumente",
        document_type_weighing_slip: "Wiegeschein",
        document_type_delivery_slip: "Lieferschein",

        bale_title: "Ballen",
        bale_delete: "Ballen löschen",

        property_material: "Material",
        property_weight: "Gewicht",
        property_weight_kg: "Gewicht Kg",
        property_supplier: "Lieferant",
        property_date: "Datum",
        property_time: "Zeit",
        property_quality: "Qualität",
        property_notes: "Notizen",
        property_location: "Standort",
        property_submitted_by: "Eingereicht von",
        property_n_bales: "Anz. Ballen",
        property_registered_bales: "Registrierte Ballen",
        property_conflicts: "Konflikte",
        property_price: "Einkaufspreis",
        property_photos: "Fotos",
        property_truck_license_plate: "Kennzeichen LKW",
        property_dispo_number: "Dispo-Nummer",
        property_bale_mark: "Ballenkennzeichnung",
        property_document_scanner: "Dokument Scanner",
        property_supplier_no: "LIEFERANTEN NR",
        property_supplier_name: "LIEFERANTEN NAME",
        property_order_no: "BESTELL NR",
        property_license_plate: "KENNZEICHEN LKW",
        property_weight_first: "1. WÄGUNG",
        property_weight_second: "2. WÄGUNG",
        property_weight_netto_1: "NETTO I",
        property_weight_netto_2: "NETTO II",
        property_doc_type: "DOKUMENT TYP",
        property_slip_nr: "DOKUMENT NR",

        modal_delivery_delete_title:
          "Sind Sie sicher, dass Sie diese Lieferung löschen möchten?",
        modal_bale_delete_title:
          "Sind Sie sicher, dass Sie diesen Ballen löschen möchten?",
        modal_cancel: "Abbrechen",
        modal_delete: "Löschen",

        title_dayreview: "Stündliche Übersicht",
        dayreview_time: "Zeit",
        dayreview_bales: "Ballen",
        dayreview_nbales: "Anz. Ballen",
        dayreview_shift_time: "Schichtbeginn",

        title_daysummary: "Zusammenfassung",
        subtitle_daysummary: "Übersicht Anlage",
        subtitle_dayreview: "Erkannte Einheiten des Tages",
        daysummary_weight: "Verarbeitetes Gewicht",
        daysummary_num_bales: "Verarbeitete Ballen",
        daysummary_material: "Verarbeitete Materialien",
        daysummary_tons: "Tonnen",
        daysummary_bales: "Ballen",

        title_devicestatus: "Geräte Status",
        devicestatus_no_disruptions: "Keine Unterbrüche festgestellt",
        devicestatus_disrupted: "Unterbrüche festgestellt",
        devicestatus_percentage_1: "Das Gerät war zu",
        devicestatus_percentage_2: "Online",

        labeling_mode_requested: "Labeling Anfragen",
        labeling_mode_randomized: "Zufällig",
        labeling_mode_pairwise: "Paarweiser Vergleich",
        labeling_mode_conflicts: "Labeling Konflikte",
        labeling_title: "Ballenmaterial bestimmen",
        quality_labeling_title: "Ballenqualität bestimmen",
        labeling_no_label: "unbestimmt",
        labeling_you_labeled: "Du hast heute",
        labeling_bales_today: "Ballen beschriftet!",
        alert_low_accuracy: "hohe Unsicherheit",
        labeling_conflicts_open: "Offene Konflikte",
        labeling_conflicts_resolved: "Gelöste Konflikte",

        liveview_title: "Autonomer Ballenscanner - Live View",
        liveview_choice_camera: "Kamera-Feed",
        liveview_choice_predictions: "AI Analyse",
        liveview_error:
          "Kein Stream verfügbar. Bitte kontaktieren Sie das UpCircle Team.",

        supplier_filter_title: "Lieferant",
        search_suppliers: "Lieferanten suchen...",
        search_companies: "Unternehmen suchen...",
        no_results_found: "Keine Lieferanten gefunden",
        no_companies_found: "Keine Unternehmen gefunden",
        clear_search: "Suche löschen",
        multi_select_title_empty: "keine",
        multi_select_title: "ausgewählt",

        settings_new_client: "Neuer Kunde",
        settings_users: "Benutzer",
        settings_create_new_user: "Neuen Benutzer erstellen",
        settings_edit_user: "Benutzer bearbeiten",
        settings_devices: "Geräte",
        settings_create_new_device: "Neues Gerät erstellen",
        settings_edit_device: "Gerät bearbeiten",
        settings_no_devices_found:
          "Keine Geräte für ausgewählten Kunden gefunden.",
        settings_device_id: "Geräte-ID",
        settings_device_display_name: "Anzeigename",
        settings_device_location_name: "Standortname",
        settings_device_description: "Beschreibung",
        settings_device_local_ip: "IP Adresse",
        settings_device_company: "Unternehmen",
        settings_device_emails: "Benachrichtigungs E-Mails",
        settings_device_add_email: "E-Mail hinzufügen",
        settings_device_filters: "Filter Klassen",
        settings_device_add_filter: "Klasse hinzufügen",
        settings_device_confirm_reboot: "Möchten Sie die Pipeline neu starten?",
        settings_device_confirm_save: "Änderungen wurden gespeichert.",
        settings_save: "Speichern",
        settings_client_create: "Kunden erstellen",
        settings_client_id: "Kunden-ID",
        settings_client_name: "Anzeigename",
        settings_client_low_accuracy_flag: "Tiefe Genauigkeit markieren",
        settings_client_add_low_accuracy_flag: "Markierung hinzufügen",
        settings_user_last_login: "Letzter Login",
        settings_user_company: "Unternehmen",
        settings_user_name: "Name",
        settings_user_language: "Sprache",
        settings_user_flags: "Benutzerflags",
        settings_user_add_flag: "Benutzerflag hinzufügen",
        settings_user_email: "E-Mail",
        settings_user_password: "Passwort",
        settings_user_error_fields:
          "Alle Eingabefelder müssen korrekt ausgefüllt sein.",
        settings_user_error_email: "Diese Email existiert bereits",
        settings_user_error_pw: "Passwort muss mindestens 6 Zeichen lang sein.",
        settings_user_confirm_create:
          "Möchten Sie einen neuen Benutzer erstellen? Es wird ungefähr eine Minute dauern, bis der neue Nutzer sichtbar wird.",
        settings_user_reset_password: "Reset Email senden",
        settings_user_reset_password_message:
          "E-Mail zum Zurücksetzen des Passworts an den Benutzer senden?",
        settings_user_change_credentials: "Anmeldedaten ändern",
        settings_user_change_credentials_message:
          "Sind Sie sicher, dass Sie die Anmeldedaten des Benutzers ändern möchten?",
        settings_yes: "Ja",
        settings_cancel: "Abbrechen",
        settings_report_standstill: "Materialfluss Stillstand melden",
        settings_stanstill_threshold: "Stillstand Schwellwert (min)",
        settings_report_stamp_inactivity: "Stamping Inaktivität melden",
        settings_stamp_inactivity_threshold: "Inaktivität Schwellwert (min)",
        settings_enable_chat_alerts:
          "Google-Chat Benachrichtigungen aktivieren",

        shift_report_saving: "Speichert...",
        shift_report_offline: "Offline",
        shift_report_last_save: "Zuletzt gespeichert",

        claims_table_card_title: "Reklamationen",
        claim_nr: "Bericht Nr.",
        claim_card_title: "Reklamation Ansicht",
        claim_images_title: "Registrierte Bilder",
        no_claims: "Keine Reklamationen erfasst.",
        claim_download_report: "Bericht Download",
        claim_download_report_title: "Reklamation Bericht Download",
        claim_download_report_generating: "Generiere Bericht",
        claim_download_report_error:
          "Beim Generieren des Berichts ist ein Fehler aufgetreten.",
        claim_delete_note_title:
          "Sind Sie sicher, dass Sie diese Notiz löschen möchten?",

        timeline_normalize: "Normalisieren",
        timeline_force_hourly: "Stündliche Daten anzeigen",

        material_flow_loading_error:
          "Fehler beim Laden des Materialstroms für das ausgewählte Datum.",
        material_flow_toggle_bbox_labeling:
          "Bounding Box Bearbeitung umschalten (B)",
        material_flow_edit: "Bearbeiten",
        material_flow_delete_text:
          "Bounding Box und assozieerter Ballen löschen",
        material_flow_confirm_text: "Bounding Box bestätigen",
        material_flow_editing_text: "Bounding Box zeichnen (E)",
        material_flow_show_in: "Im Materialfluss anzeigen",

        demo_mode_company_displayname: "",

        productGroup: "Material Gruppe",
        uncategorized: "unkategorisiert",

        // Shared Components
        labeling_select_recommended: "Empfohlen",
        labeling_select_others: "Andere",
        labeling_request: "Labeling Anfrage",
        labeling_skip: "Balle überspringen",
        labeling_accept: "Bestätigen und weiter",
        labeling_no_more_requests: "Keine weiteren labeling Anfragen gefunden.",
        license_agreement_title: "Lizenzvereinbarung",
        license_agreement_decline: "Ablehnen",
        license_agreement_accept: "Akzeptieren",

        // Supplier Table Component
        supplier_name: "Lieferantenname",
        table_columns: "Tabellen Spalten",
        all: "Alle",
        reset: "Reset",
        tier: "Stufe",
        score: "Bewertung",
        deliveries: "Lieferungen",
        claims: "Reklamationen",
        claims_per_ton: "Reklamationen/20t",
        claims_per_delivery: "Reklamationen/Lieferung",
        total_bales_in_production: "Ballen in Beschickung",
        bales_with_plastic_foils: "Kontaminierte Ballen (%)",
        plastic_foils_per_bale: "Durchschn. Kunststoffanteil in allen Ballen",
        contamination_level: "Detektierungen pro Balle",
        items_per_page: "Elemente pro Seite",
        found_suppliers: "Lieferanten gefunden",
        filtered_by: "Gefiltert nach",
        loading_supplier_details: "Lieferantendetails werden geladen...",
        no_suppliers_found:
          "Keine Lieferanten gefunden, die den aktuellen Filtern entsprechen",
        no_supplier_data: "Keine Lieferantendaten verfügbar",
        search_results_info: "Suchergebnisse",
        none: "Keine",
        search_for: "Suche nach",
        to: "bis",
        brown_paper_percentage: "Braunfaseranteil",
        avg_brown_paper_percentage: "Durchschn. Braunfaseranteil",

        // Supplier chart component
        contaminant: "Verunreinigung",
        time_range: "Zeitraum",
        contaminated_bales: "Kontaminierte Ballen",
        contaminated_bales_percentage: "von {{y}} ({{z}}%)",
        foils_detected: "Durchschnittliche Detektionen pro Ballen (alle Ballen)",
        x_per_bale: "pro Ballen",
        contaminated_area: "Kontaminierter Bereich",
        x_of_bale_surface: "der Ballenoberfläche",
        contaminated_qty: "Kontaminierter Anteil",
        contaminated_qty_label: "Durchschnittliche Detektionen \npro kontaminiertem Ballen",
        contaminations_in_contaminated_bales_tooltip: "Durchschnittliche Detektionen pro kontaminierter Balle",
        contaminations_in_contaminated_bales_value: "pro Ballen",

        qty: "Menge",
        area: "Bereich",
        contaminant_count: "Durchschnittliche Detektionen pro Ballen",
        contaminant_foils_per_bale: "{{contaminant}}-Folien pro Ballen",
        contaminated_area_per_bale: "Kontaminierter Bereich pro Ballen",
        contaminated_bales_in_percentage: "Kontaminierte Ballen %",

        // Supplier chart tooltips
        tooltip_contaminated_qty: "Zeigt das Kontaminationslevel verunreinigter Ballen.",
        tooltip_qty: "Zeigt das Kontaminationslevel im Durchschnitt aller Ballen.",
        tooltip_area: "Zeigt kontaminierte Fläche pro Balle als Durchschnitt.",

        // Supplier Overview Component
        data_range: "Datenbereich",
        overview: "Übersicht",
        plant_process: "Anlagen Beschickung",
        issues: "Probleme",
        code: "Code",
        total_tonnage: "Gesamttonnage",
        tons_ytd: "Tonnen YTD",
        filter_active: "Filter Aktiv",
        remove_filter: "Filter entfernen",

        // Supplier chart section
        supplier_contamination_analysis: "Analyse der Lieferantenkontamination",

        // OverviewTab Component
        deliveries_over_time: "Lieferungen im Zeitverlauf",
        material_distribution: "Materialverteilung",
        latest_issue: "Letztes Problem",
        issue_trend: "Problemtrend",
        last_30_days: "Letzte 30 Tage",
        recent_deliveries: "Letzte Lieferungen",
        no_issues_found: "Keine Probleme gefunden",
        issue_reported: "Problem gemeldet",
        increasing: "Zunehmend",
        decreasing: "Abnehmend",
        stable: "Stabil",
        no_issues: "Keine Probleme",
        no_data: "Keine Daten",
        tons: "Tonnen",
        bales: "Ballen",
        unknown_weight: "Unbekanntes Gewicht",
        unknown_bales: "Unbekannte Ballen",
        no_material_data:
          "Keine Materialdaten für den ausgewählten Zeitraum verfügbar",
        no_delivery_data:
          "Keine Lieferdaten für den ausgewählten Zeitraum verfügbar",
        weight_tons: "Gewicht (Tonnen)",
        number_of_deliveries: "Anzahl der Lieferungen",
        date: "Datum",
        delivery_singular: "Lieferung",
        deliveries_plural: "Lieferungen",

        // DeliveriesTab Component
        delivery_history: "Lieferungsverlauf",
        deliveries_count: "von diesem Lieferanten",
        delivery: "Lieferung",
        no_deliveries_found:
          "Keine Lieferungen für diesen Lieferanten gefunden",
        no_deliveries_found_for_material:
          "Keine Lieferungen für {{material}} gefunden",

        // PlantProcessTab Component
        plant_process_history: "Beschickungsverlauf der Anlage",
        loading_processing_history: "Beschickungsverlauf wird geladen...",
        no_processing_history:
          "Kein Beschickungsverlauf für diesen Lieferanten verfügbar.",
        loading_more: "Weitere Einträge werden geladen...",
        no_more_entries: "Keine weiteren Einträge",
        processed: "verarbeitet",
        processing_field: "Feld",
        processing_shift: "Schicht",
        processing_shift_worker: "Bediener",

        // IssuesTab Component
        issue_history: "Reklamationsverlauf",
        issues_count: "Reklamation",
        issues_count_plural: "Reklamationen",
        no_confirmed_issues:
          "Keine bestätigten Reklamationen für diesen Lieferanten",
        delivery_date: "Lieferdatum",
        claim_issues_filter: "Reklamationspunkte gefiltert",

        // Filter Components
        filter_material: "Material",
        filter_categories: "Reklamationsgrund",
        filter_sort_by: "Sortieren nach",
        filter_date_range: "Datumsbereich",
        filter_deliveries_range: "Anzahl Lieferungen",
        filter_tonnage_range: "Gesamttonnage",
        filter_bales_range: "Ballen in Beschickung",
        filter_reset: "Filter zurücksetzen",
        claim_without_issues: "Andere",
        sort_by_name: "Name",
        sort_by_score: "Bewertung (Hoch zu Niedrig)",
        sort_by_deliveries: "Lieferungen (Hoch zu Niedrig)",
        sort_by_claims: "Reklamationen (Niedrig zu Hoch)",
        all_materials: "Alle Materialien",
        select_dates: "Daten auswählen",
        all_time: "Gesamte Zeit",
        this_year: "Dieses Jahr",

        // GroupingOptions Component
        group_all_suppliers: "Alle Lieferanten",
        group_by_material: "Nach Material",
        group_by_ranking: "Nach Ranking-Stufen",
        group_all_description: "Alle Lieferanten anzeigen",
        group_material_description: "Lieferanten nach Materialtyp gruppieren",
        group_ranking_description: "Lieferanten nach Ranking-Stufen gruppieren",
        coming_soon: "Demnächst verfügbar",

        // SuppliersByMaterial Component
        supplier_count_singular: "Lieferant",
        supplier_count_plural: "Lieferanten",
        deliveries_count_material: "Lieferungen",
        total_weight: "Gesamtgewicht",
        issue_count_singular: "Reklamation",
        issue_count_plural: "Reklamationen",
        avg_score: "Durch. Bewertung",
        avg: "Durchschn.",

        // SupplierInsightsPage
        show_filters: "Filter anzeigen",
        hide_filters: "Filter ausblenden",
        rank: "Rang",

        // Log Insights page
        log_insights_company: "Firma",
        log_insights_user: "Benutzer",
        log_insights_source: "Quelle",
        log_insights_event: "Ereignis",
        log_insights_showing_logs: "Anzeigen",
        log_insights_logs: "Logs",
        log_insights_load_more: "Mehr laden",
        log_insights_load_all: "Alles laden",

        total_select_content_events: "Gesamte select_content Ereignisse",
        unique_content_types: "Eindeutige Inhaltsarten",
        content_type_analytics: "Inhaltsartenanalyse",

        total: "Gesamt",
        other_materials: "Andere Materialien",

        // Table Tooltips
        material_specific_value: "Wert für ausgewählte Gruppe",
        overall_value: "Gesamtwert über alle Gruppen",
        insufficient_data: "Ungenügend Daten für zuverlässige Aussage",
        info_total_bales_in_production:
          "Anzahl Ballen, die von diesem Lieferanten in der Produktion beschickt und verarbeitet wurden.",
        info_bales_with_plastic_foils:
          "Prozentsatz an Ballen, welche Verunreinigungen (Kunststofffolien) enthalten. Gemessen an allen Ballen des Lieferanten in der Beschickung.",
        info_plastic_foils_per_bale:
          "Durchschnittliche Anzahl der gemessenen Verunreinigungen auf die Gesamtzahl der Ballen. Gemessen an allen Ballen des Lieferanten in der Beschickung.",
        info_contamination_level:
          "Durchschnittliche Anzahl detektierter Verunreinigungen (Kunststofffolien) pro verunreinigter Balle. Gemessen an allen Ballen des Lieferanten in der Beschickung.",
        info_brown_paper_percentage:
          "Durchschnittlicher Braunfaseranteil aller Ballen in der Beschickung.",
        info_total_tonnage:
          "Gesamtgewicht (in Tonnen) aller Ballen, die dieser Lieferant in den ausgewählten Zeitraum geliefert hat.",
        info_claims:
          "Anzahl erfasste Reklamationen für Lieferanten. Definiere die berücksichtigten Reklamationstypen in den Filteroptionen.",
        info_claims_per_ton:
          "Anzahl erfasste Reklamationen pro 20t. Definiere die berücksichtigten Reklamationstypen in den Filteroptionen.",
        info_claims_per_delivery:
          "Anzahl erfasste Reklamationen pro Lieferung. Definiere die berücksichtigten Reklamationstypen in den Filteroptionen.",
        claim_filter_all: "Alle",
        claim_filter_selected: "Ausgewählt",
        export_to_excel: "Excel",

        // Grid toggle
        grid_show: "Raster einblenden",
        grid_hide: "Raster ausblenden",

        // Timeline y-axis titles
        timeline_material_percentage: "Materialanteil %",
        timeline_material_count: "Anzahl Ballen",
        timeline_bale_count: "Anzahl Ballen",
        timeline_contaminants_count: "Anzahl Detektionen",
        timeline_brown_paper_percentage: "Braunanteil %",
        timeline_brown_paper_raw: "Aufträger-Braunanteil",
        timeline_brown_paper_ema: "Pulper-Braunanteil",
        timeline_volume: "Volumen m³",

        // Timeline time unit patterns
        timeline_per_unit: "{{value}} pro {{unit}}",
        timeline_time_unit_min: "{{minutes}} Minuten",
        timeline_time_unit_hour: "Stunde",
        timeline_time_unit_day: "Tag",

        // Timeline settings
        timeline_settings_title: "Timeline Einstellungen",
        timeline_settings_time_interval: "Zeitintervall Datenpunkte",
        timeline_settings_ema_period: "Glättungsperiode",
        timeline_settings_use_ema: "Glättung verwenden",
        timeline_settings_use_normalized: "Normalisiert anzeigen",
        timeline_settings_show_suppliers: "Lieferanten anzeigen",

        // Timeline settings tooltips
        timeline_tooltip_time_interval:
          "Wählen Sie das Zeitintervall für die Datenpunkte aus. Daten werden jeweils für das ausgewählte Intervall zusammengefasst (Summe / Durchschnitt).",
        timeline_tooltip_use_ema:
          "Aktivieren Sie Glättung der Daten, was die Vermischung von Material über Zeit wiederspiegelt. Die Glättung wird mit einem 'Exponential Moving Average' (EMA) berechnet. Dabei werden vergangene Datenpunkte berücksichtigt, wobei die Gewichtung mit zunehmender Entfernung abnimmt.",
        timeline_tooltip_ema_period:
          "Legen Sie die Anzahl der Datenpunkte fest, welche für die Glättung berücksichtigt werden. Längere Perioden ergeben eine glattere Kurve und eine stärkere Verzögerung in der Reaktion auf Änderungen.",
        timeline_tooltip_use_normalized:
          "Daten als normalisierte Prozentsätze für relativen Vergleich anzeigen",
        timeline_tooltip_show_suppliers:
          "Zeigen Sie an, von welchen Lieferanten das Material stammt. Daten kommen aus dem Stamping.",

        // Timeline card
        timeline_card_title: "Timeline Materialverarbeitung",

        // Timeline names
        timeline_bale_count_name: "Verarbeitete Ballen",
        timeline_material_distribution_name: "Materialverteilung",
        timeline_plastics_type_distribution_name: "Plastiktypen",
        timeline_contaminants_name: "Störstoffe",
        timeline_brown_paper_name: "Braunanteil",
        timeline_volume_flow_name: "Volumenstrom",

        // Time units
        time_unit_min: "min",
        time_unit_day: "day",

        tag_show: "Detektionen einblenden",
        tag_hide: "Detektionen ausblenden",
      },
    },
  },
});

export default i18n;
